export default {
    _prefix: "EvaluationAssistanceStatus",
    label: "Evaluation Assistance",
    status: {
        questionCount: (data: { count: number }) => {
            return "{{count}} question(s) answered";
        },
        tooltipText: (data: {
            answeredQuestionCount: number;
            totalQuestionCount: number;
        }) => {
            return "Evaluation Assistance successfully answered {{answeredQuestionCount}} of {{totalQuestionCount}} question(s)";
        },
    },
};
